import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import {t} from 'i18next';
import {useDispatch} from 'react-redux';
import {setProjectChange} from '../../../redux/slices/bulkUserEditSlice';
import styles from './style.module.scss';
import {useFieldFocusStyle} from '../../../hooks/utils/useFieldFocusStyle';

interface Option {
  [key: string]: any;
}
interface AurSelectProps {
  label: string;
  optionList: Option[];
  idKey: string;
  nameKey: string;
  field: {
    value: string | undefined;
    onChange: (event: SelectChangeEvent<string>) => void;
    onBlur: () => void;
  };
  fieldState: {
    error?: {
      message?: string;
    };
  };
}

export const AurBulkSelect = (props: AurSelectProps) => {
  const {label, optionList, field, fieldState, idKey, nameKey} = props;

  const {borderClass, focusHandler, mouseKeyDownHandler} = useFieldFocusStyle({
    tabFocusClass: styles.tabFocusedBorder,
    mouseFocusClass: styles.mouseFocusedBorder,
  });

  const dispatch = useDispatch();
  const selectedId = field.value ?? '';

  const handleChange = (event: SelectChangeEvent<string>) => {
    field.onChange(event);
    if (label === t('addEditTeamMember.form.projects'))
      dispatch(setProjectChange(true));
  };

  return (
    <FormControl
      variant="filled"
      className={`aur-select-client ${borderClass}`}
      error={!!fieldState.error}
    >
      <InputLabel
        id={`demo-simple-select-label-${label}`}
        className={`select-label ${fieldState.error?.message && 'label-error'}`}
      >
        {label}
      </InputLabel>
      <Select
        labelId={`demo-simple-select-label-${label}`}
        label={label}
        value={selectedId}
        onChange={handleChange}
        className="custom-select"
        inputProps={{
          className: fieldState.error?.message ? 'inputError' : 'input-noError',
        }}
        MenuProps={{
          disableScrollLock: true,
        }}
        onFocus={focusHandler}
        onMouseDown={mouseKeyDownHandler}
      >
        {optionList.map((option: Option) => (
          <MenuItem key={option[idKey]} value={option[idKey]}>
            {option[nameKey]}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText className={fieldState.error?.message && 'label-error'}>
        {fieldState.error?.message}
      </FormHelperText>
    </FormControl>
  );
};
